import React from 'react';
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";

export default class HeaderForm extends React.Component<any, any> {
  render() {
    return (
      <div className="mt-2 mb-4">
        <span className={this.props.step === 0 ? "fw-bold" : ""}>{this.props.first}</span>
        {this.props.second && <>
            <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
            <span className={this.props.step === 1 ? "fw-bold" : ""}>{this.props.second}</span>
        </>}
        {this.props.third && <>
            <KeyboardArrowRightIcon className="color-secondary fw-bold"/>
            <span className={this.props.step === 2 ? "fw-bold" : ""}>{this.props.third}</span>
        </>}
      </div>
    );
  }
}
